@if (section().content) {
  <div [class.inner-container]="!section().content.fullWidth">
    <div [class.negative-margin]="section().content.fullWidth">
      <ng-container
        *ngTemplateOutlet="section().content.redirect ? linkWrapper : bannerImage"
      ></ng-container>
    </div>
  </div>
}

<ng-template #bannerImage>
  @if (video()) {
    <video #bannerVideo class="w-full" autoplay muted loop playsinline preload="auto">
      <source [src]="video()" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  } @else {
    <img
      [src]="section().content.img?.url || 'assets/images/default-banner.png'"
      alt="banner"
      class="w-full"
    />
  }
</ng-template>

<ng-template #linkWrapper>
  <a [attr.href]="formatUrl(section().content.redirect)" target="_blank" rel="noopener noreferrer">
    <ng-container *ngTemplateOutlet="bannerImage"></ng-container>
  </a>
</ng-template>
